import { create } from "zustand";

type IfModalOpenedStore = {
  ifModalOpened: boolean;
  setIfModalOpened: (arg: boolean) => void;
};

export const useIfModalOpenedStore = create<IfModalOpenedStore>((set) => ({
  ifModalOpened: false,
  setIfModalOpened: (arg) => set({ ifModalOpened: arg }),
}));
